import {
  REQUEST_COMPLETED_STATUS,
  REQUEST_DENIED_STATUS,
  REQUEST_IN_PROGRESS_STATUS,
  REQUEST_PENDING_STATUS,
} from '../../../../../constants/request'
import { usePageShowReload, useRegisterReload } from '../../../../../hooks'
import { getRequestBoardItems } from '../../RequestBoard.utils'
import { useRequestBoardColumn } from '../useRequestBoardColumn'
import { useRequestBoardExtra } from '../useRequestBoardExtra'
import { useRequestBoardItemSync } from '../useRequestBoardItemSync'

import {
  isRequestBoardLoading,
  isRequestBoardReloaded,
} from './useRequestBoard.utils'

export function useRequestBoard({ filterValues, isEnabled, onRegisterReload }) {
  const { extra, handleLoadExtra } = useRequestBoardExtra({ filterValues })

  const pendingColumn = useRequestBoardColumn({
    filterValues,
    isEnabled,
    status: REQUEST_PENDING_STATUS,
    onLoadPage: handleLoadExtra,
  })

  const inProgressColumn = useRequestBoardColumn({
    filterValues,
    isEnabled,
    status: REQUEST_IN_PROGRESS_STATUS,
    onLoadPage: handleLoadExtra,
  })

  const completedColumn = useRequestBoardColumn({
    filterValues,
    isEnabled,
    status: REQUEST_COMPLETED_STATUS,
    onLoadPage: handleLoadExtra,
  })

  const deniedColumn = useRequestBoardColumn({
    filterValues,
    isEnabled,
    status: REQUEST_DENIED_STATUS,
    onLoadPage: handleLoadExtra,
  })

  const columns = [
    pendingColumn,
    inProgressColumn,
    completedColumn,
    deniedColumn,
  ]

  async function handleReload() {
    return Promise.all(columns.map(column => column.handleReload())).then(
      isRequestBoardReloaded
    )
  }

  const { handleReloadItem, handleStartItemAction } = useRequestBoardItemSync({
    columns,
    filterValues,
    onLoadItems: handleLoadExtra,
    onReload: handleReload,
  })

  useRegisterReload({ reload: handleReload, onRegisterReload })

  usePageShowReload(handleReload)

  return {
    columns,
    extra,
    handleReload,
    handleReloadItem,
    handleStartItemAction,
    isLoading: isRequestBoardLoading(columns),
    items: getRequestBoardItems(columns),
  }
}
